import React from 'react'

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { UserSource } from '../types'

interface Props {
  label?: string
  value: UserSource
  onChange: (val: UserSource) => void
  disabled?: boolean
}

const SourcePicker: React.FC<Props> = ({ label, value, onChange, disabled = false }) => {
  const handleChange = (event: SelectChangeEvent<UserSource>) => {
    onChange(event.target.value as UserSource)
  }
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={handleChange} disabled={disabled}>
        {Object.values(UserSource).map((source) => (
          <MenuItem key={source} value={source}>
            {source}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SourcePicker
